
import Vue from 'vue'
import MaterialsQuotationTransformer from '@/transformers/purchase/materialsQuotation'
import errorHandler from '@/utils/errorHandler'


export default (id, supplies) => {
	const payload = MaterialsQuotationTransformer.send(supplies)
	const request = errorHandler(Vue.$http.put(`purchase/materialsquotation/${id}/`, 
																						 payload))
	return request
		.then(response => response.data)
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendMaterialQuotation.js